export default {"src":"/_next/static/media/EHACare-QappPerson.919d1b90.svg","height":106,"width":117};